<template>
  <div>
    <VTextField
      v-model="internalValue"
      autocomplete
      outlined
      label="Confirmation Code"
      name="code"
    />
  </div>
</template>

<script>
  // Utilities
  import {
    mapMutations
  } from 'vuex'

  export default {
    name: 'Code',

    mounted(){
      if(this.$route.query.code){
        this.setConfirmationCode(this.$route.query.code)
      }
    },

    computed: {
      internalValue: {
        get () {
          return this.$store.state.confirmationcode
        },
        set (val) {
          this.setConfirmationCode(val)
        }
      }
    },

    methods: {
      ...mapMutations(['setConfirmationCode']),
    }
  }
</script>
